export default __webpack_public_path__ + "static/media/viki.47052967.png";